
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IPSTenantKeyService } from '@ips/common-angular';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {
  title = 'Record Retrieval Client Portal';

  constructor(private readonly primeng: PrimeNG, private readonly tenantKeyService: IPSTenantKeyService) {}

    ngOnInit() {
        this.primeng.ripple.set(true);
        this.tenantKeyService.selectedTenantChange.subscribe(tenant => {
            // if you need to do something with the tenant change
        });
    }

}
